export default {
  async resetState (context) {
    context.commit('brands/reset')
    context.commit('cards/reset')
    context.commit('config/reset')
    context.commit('customer/reset')
    context.commit('display/reset')
    context.commit('loans/reset')
    context.commit('appElement/reset')
    context.commit('offers/reset')
    context.commit('origination/reset')
    context.commit('payment/reset')
    context.commit('store/reset')
    context.commit('session/reset')
    context.commit('referral/reset')
  }
}
